<div class="window-embed" [ngClass]="{'active': active}">
    <div class="window-hubspot-container" *ngIf="context.type === 'sale'">
        <div class="meetings-iframe-container" [attr.data-src]="'https://app.hubspot.com/meetings/' + this.context.value +'?embed=true'"></div>

        <div id="window-hubspot-injector"></div>
    </div>
</div>
